import { render, staticRenderFns } from "./rfm-segment.vue?vue&type=template&id=1c4e56b2"
import script from "./rfm-segment.vue?vue&type=script&lang=js"
export * from "./rfm-segment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports